import React from 'react';
import { StyledMessage } from '../../styles/devices/Labels'
import { StyledEditMessage, StyledOverlappingMessage } from '../../styles/devices/Labels';
import { StyledEditOverlappingContainer, StyledSavingModeContainer, StyledTitleContainer  } from '../../styles/devices/Container';
import { messages_common } from '../../types/Messages';

import { colour_lookup } from '../../Colours';

// Icons
import { Icon } from '@iconify/react';
import rectangleLandscape28Filled from '@iconify/icons-fluent/rectangle-landscape-28-filled';
import warningIcon from '@iconify/icons-carbon/warning';

// -----------------CALENDAR CONTAINER DISPLAY MESSAGES---------------------------------------

export const StandardMainDisplayMessage = ({message}: {message:string}) => {
    return (
        <StyledMessage>
            <div>
                <span> {message}</span>
            </div>
        </StyledMessage>
    )

}

export const SelectMessage = () => {
    return (    
        <StyledMessage>
          <div>      
            <span style={{textAlign: 'left'}}> <label style={{ fontWeight: 'bold' }}>Power -</label> provides a calendar to allow the user to control if and when the instrument saves power.</span>
            <span style={{textAlign: 'left'}}> <label style={{ fontWeight: 'bold' }}>NX-42WR Audio -</label> the user can choose a time slot on calendar view to control when WAV recordings are made on the instrument.</span>
            <span style={{textAlign: 'left'}}> <label style={{ fontWeight: 'bold' }}>Weekly Restart -</label> the instrument restarts once a week at a chosen time, on the same day every week.</span>
            <span style={{textAlign: 'left'}}> <label style={{ fontWeight: 'bold' }}>Do Not Disturb (DND) -</label> the user can choose to disable all email alerts during particular hours, such as overnight.</span>
            <br/><br/><br/>
            <span>Select a Position in the left menu to start.</span>
          </div> 
        </StyledMessage>      
    )
}

export const DisabledMessage = () => {
    return (
      <StyledMessage>
        <div>
          <span>Power Saving is currently disabled for this Position.</span>
          <span>The system will be permanently ON.</span>
          <span>Enable using the toggle in the top right corner.</span>
        </div>
      </StyledMessage>
    )
}

//----------------------EDIT PANEL DISPLAY MESSAGES----------------------------------------------

export const StandardEditDisplayMessage = ({message}: {message:string}) => {
  return (
      <StyledEditMessage>
          <div>
              <span> {message}</span>
          </div>
      </StyledEditMessage>
  )

}

export const OverlappingMessage = ({ isOverlapping }: { isOverlapping: any; }) => {

  return(
    <StyledEditOverlappingContainer>
      <StyledTitleContainer>
        <Icon width='30px' height='30px' color={colour_lookup('red')} icon={warningIcon} /> 
          <p>Overlapping Schedules</p>
      </StyledTitleContainer>
      <StyledOverlappingMessage> {messages_common.overlap} </StyledOverlappingMessage>
    </StyledEditOverlappingContainer>
  )
}

export const PowerSavingMessage = () => {
  return(
    <StyledSavingModeContainer>
      <StyledTitleContainer>
        <Icon width='30px' height='30px' color={colour_lookup('pink')} icon={rectangleLandscape28Filled} /> 
        <p>Power Saving</p>
      </StyledTitleContainer> 
    </StyledSavingModeContainer> 
  )
}


